module.exports = __webpack_public_path__ + "fonts/ea0a337.otf";